import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
const NotFound = () => {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-center">
        <h1 className="md:text-[200px] text-5xl font-bold text-webOranage py-7">404</h1>
        <p className="text-5xl text-gray-600">Oops ! Page Not Found</p>
        <Link
      to="/"
      className="relative inline-flex items-center px-6 py-3 mt-5 text-white bg-secondary font-semibold text-lg rounded-full border-2 border-yellow-500 transition-all duration-300 hover:bg-yellow-500 hover:text-black"
    >
      BACK TO HOME
      <span className="ml-3 p-2 bg-white rounded-full text-yellow-500 transition-transform duration-300 transform hover:translate-x-1">
        <FaArrowRight />
      </span>
    </Link>
      </div>
    );
  };
  
  export default NotFound;
  